import { render, staticRenderFns } from "./mobile-nav-primary.vue?vue&type=template&id=70a8163f&"
import script from "./mobile-nav-primary.vue?vue&type=script&lang=js&"
export * from "./mobile-nav-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports